import { cn } from '@shared/lib/utils';

import type { ReactNode } from 'react';
import { HStack, Stack } from '../layout/stack';
import { Text } from '../typography/text';

type KpiCardCompactProps = {
  label: string;
  value: number | string;
  trend?: ReactNode;
  formatValue?: (value: number) => string;
  className?: string;
};

const defaultFormatValue = (value: number) => new Intl.NumberFormat().format(value);

export function KpiCardCompact({
  label,
  value,
  trend,
  formatValue = defaultFormatValue,
  className,
}: KpiCardCompactProps) {
  const formattedValue = typeof value === 'number' ? formatValue(value) : value;

  return (
    <Stack
      gap="xs"
      className={cn(
        'w-full min-w-0 overflow-hidden rounded-lg border border-border p-3',
        className
      )}
    >
      <Text size="xs" color="muted" className="break-words sm:whitespace-nowrap">
        {label}
      </Text>
      <HStack
        gap="sm"
        align="center"
        className="w-full min-w-0 flex-wrap items-center justify-between gap-3"
      >
        <Text className="whitespace-nowrap text-base font-semibold text-card-foreground">
          {formattedValue}
        </Text>
        {trend}
      </HStack>
    </Stack>
  );
}
